import { render, staticRenderFns } from "./SupportedStoryTypes.vue?vue&type=template&id=7865152e&scoped=true&"
import script from "./SupportedStoryTypes.vue?vue&type=script&lang=js&"
export * from "./SupportedStoryTypes.vue?vue&type=script&lang=js&"
import style0 from "./SupportedStoryTypes.vue?vue&type=style&index=0&id=7865152e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7865152e",
  null
  
)

export default component.exports